<template>
    <div class="body">

        <p  class="font1" style="padding-top: 8vh;">为君聊赋今日诗</p>
        <p  class="font1" style="padding-top: 1vh;">努力请从今日始</p>
        
        <div>
            <p class="font2" style="padding-top: 3vh;">你希望在富学宝典平台遇见哪些好课程？</p>
            <p class="font2" style="padding-top: 1vh;">请写下你2024年的学习清单吧！</p>
        </div>
  
        <div style="display:flex;flex-wrap:wrap;justify-content:center;">
            <div class="wrapper">
                <textarea placeholder="请写下你的学习清单吧！" v-model="comment" id="text" rows="4" style="overflow: hidden; word-wrap: break-word; resize: none; height: 127px; "></textarea>
            </div>
            <button @click="submit">提交</button>
        </div>
    </div>
</template>
  
<script>
import { getArray } from '../../utils/course'
export default {
    props: ["ReportData"],
    data() {
        return {
            thisCourseList: [],
            studyList: '',
            defaultProps: {
                children: 'children',
                label: 'label'
            },
            comment: '',
        }
    },
    created() {
        this.thisCourseList = getArray()
    },
    methods: {
        submit() {
            this.studyList = ''
            if(!this.comment) {
                this.$message({
                    message: '请说说您的学习计划',
                    type: 'warning',
                    center: true
                })
            return
            }
            const view = {
                comment: this.comment,
                studyList: this.studyList
            }
            this.$emit('submit',view)
            // console.log('提交我的留言' + this.comment)
        },
        handleCheckChange(data, checked, indeterminate) {
          // console.log(this.$refs.tree.getCurrentKey())
          //     console.log(this.studyList)
        }
    }
}
</script>
  
<style scoped>
.body {
    background: url("../../assets/logo.jpg") 15px calc(100% - 20px) no-repeat,
                url("../../assets/logo2.png") right  top  no-repeat,
                url("../../assets/24July/bg.jpg")  no-repeat;
    background-size: 17% 8%,110px 35px,cover;
    width: 100%;
    height: 100vh;
}
  
.font1 {
    width: 90%;
    margin: 0 auto;
    /* text-align: center; */
    font-size: 20px;
    color: #176ed2;
    font-weight: bold;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font4 { 
    z-index: 99;
    margin: 0;
    padding: 0.7vh 21px 7px 21px;
    color: #000;
    font-size: 1.7rem;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font2 { 
    z-index: 99;
    margin: 0;
    padding: 7px 21px 17px 21px;
    color: #000;
    font-size: 1.1rem;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
  
.font3 { 
    z-index: 99;
    margin: 0;
    padding: 7px 21px 17px 21px;
    color: #000;
    font-size: 1.1rem;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
  

#text {
    width: 270px;
    overflow: hidden;
    background-color:#d4d1f1;
    color: #7b6de4;
    font-family: Courier, monospace;
    font-weight: normal;
    font-size: 21px;
    resize: none;
    line-height: 40px;
    padding-left: 27px;
    padding-right: 27px;
    padding-top: 25px;
    padding-bottom: 21px;
    /* background-image: url(https://static.tumblr.com/maopbtg/E9Bmgtoht/lines.png); */
    background-repeat: repeat-y, repeat;
    -webkit-border-radius: 12px;
    border-radius: 12px;
    -webkit-box-shadow: 0px 2px 14px #000;
    box-shadow: 0px 2px 14px #000;
    border-top: 1px solid #b5afe3;
    border-bottom: 1px solid #b5afe3;
}
  
.wrapper {
    width: 87%;
    height: auto;
    margin-bottom: 21px;
    display: flex;
    justify-content: center;
}
.btn{
    position: absolute;
    bottom:13%;
    display: flex;
    justify-content: center;
    width: 100%;
}
button {
    background: #b5afe3;
    font-family: inherit;
    padding: 0.6em 1.3em;
    font-weight: 900;
    font-size: 15px;
    border: 2px solid black;
    border-radius: 5px;
    box-shadow: 1px 1px;
}

button:active {
    transform: translate(0.05em, 0.05em);
    box-shadow: 0.05em 0.05em;
}
</style>